import { graphql } from 'babel-plugin-relay/macro';
import { commitMutationPromise } from '../lib/graphqlUtils';
import { CreateWordOrderAnswerMutation } from './__generated__/CreateWordOrderAnswerMutation.graphql';
const mutation = graphql`
  mutation CreateWordOrderAnswerMutation($input: CreateWordOrderAnswerInput!) {
    createWordOrderAnswer(input: $input) {
      answer {
        id
      }
    }
  }
`;

const commit = (
  environment: any,
  studyRecordId: string,
  exerciseId: string,
  isCorrect: boolean,
  response: string[],
) =>
  commitMutationPromise<CreateWordOrderAnswerMutation>(environment, {
    mutation,
    variables: {
      input: {
        studyRecordId,
        exerciseId,
        isCorrect,
        response,
      },
    },
  });

export default {
  commit,
};
